/// <reference types="@lib/types" />
import { CoreUtils } from "../core";
export const WebsiteUtils = {
    theme: {
        fromWebsite(w) {
            const { fonts, colors, sections } = w;
            return {
                font: {
                    header: `'${fonts.heading.family}', ${fonts.heading.category};`,
                    body: `'${fonts.body.family}',Verdana,Helvetica,${fonts.body.category};`,
                    size: 16,
                },
                colors: {
                    primary: colors.primary,
                    primary_text: colors.primary_text,
                    text: colors.text,
                    background: colors.background,
                    success: "#51a351",
                    warning: "#f89406",
                    error: "#bd362f",
                },
                color: {
                    primary: colors.primary,
                    primary_text: colors.primary_text,
                    text: colors.text,
                    background: colors.background,
                    success: "#51a351",
                    warning: "#f89406",
                    error: "#bd362f",
                },
                status_colors: {
                    complete: "#51A351",
                    onroute: "#00BFFF",
                    ready: "#0080FF",
                    confirmed: "#B7D024",
                    unconfirmed: "#efbb1e",
                    awaiting_payment: "#efbb1e",
                    cancelled: "#BD362F",
                },
                button: {
                    height: 38,
                },
                box: {
                    background: colors.box,
                    text: colors.box_text,
                    border: CoreUtils.colors.shadeAlternate(0.16, colors.box),
                },
                input: {
                    background: CoreUtils.colors.shadeAlternate(0.02, colors.box),
                    text: CoreUtils.colors.shadeAlternate(0.02, colors.box_text),
                    border: CoreUtils.colors.shadeAlternate(0.2, colors.box),
                    height: 38,
                    fontSize: 16,
                },
                top_nav: {
                    zindex: 10,
                    height: 70,
                    background_color: sections.top_nav.color_background,
                    text_color: sections.top_nav.color_text,
                },
                side_nav: {
                    zindex: 9,
                    width: 70,
                    background_color: colors.box,
                    text_color: colors.box_text,
                },
                slide_panel: {
                    zindex: 9,
                    background_color: colors.box,
                    text_color: colors.box_text,
                },
                footer: {
                    background: sections.footer.color_background,
                    text: sections.footer.color_text,
                },
                content_width: {
                    xs: 360,
                    sm: 480,
                    md: 720,
                    lg: 1000,
                    xl: 1200,
                },
                breakpoints: CoreUtils.ui.breakpoints,
            };
        },
    },
    settings: {
        defaultTopNavLinkIds() {
            return [
                "about_us",
                "location",
                "contact_us",
                "order",
                "booking",
            ];
        },
        defaultTopNavLinks() {
            return [
                {
                    _id: "about_us",
                    name: "About Us",
                    link: "",
                },
                {
                    _id: "location",
                    name: "Location",
                    link: "",
                },
                {
                    _id: "contact_us",
                    name: "Contact Us",
                    link: "",
                },
                {
                    _id: "order",
                    name: "Order Online",
                    link: "",
                },
                {
                    _id: "booking",
                    name: "Book a Table",
                    link: "",
                },
            ];
        },
    },
};
//# sourceMappingURL=index.js.map